<template>
  <flow-part :id="$options.name">
    <template #heading>
      <h2>Wat is je aansluiting?</h2>
    </template>
    <template #content>
      <div class="input-group vertical">
        <BigRadioInput id="gas-and-electricity" v-model="radioOption" title="Gas en stroom"
          subtitle="Dit heeft 95% van de huishoudens" :value="false" name="usage-type-radio"
          @click="scrollIfPrefilled(radioOption, false)" />

        <BigRadioInput id="electricity-only" v-model="radioOption" title="Alleen stroom"
          subtitle="Bijvoorbeeld stadsverwarming of warmtepomp" :value="true" name="usage-type-radio"
          @click="scrollIfPrefilled(radioOption, true)" />
      </div>
    
      <step-info-toggle title="Hoe weet ik dit?">
        <template #content>
          Wordt jouw huis verwarmd met een cv-ketel met een gasaansluiting, of kook je op een gasfornuis? Dan heb je een
          gasaansluiting en kies je hier voor gas en stroom.<br><br>

          Sommige woningen hebben geen gasaansluiting. Dit is het geval als je bijvoorbeeld stadsverwarming of
          blokverwarming hebt, of wanneer je in een modern huis of appartement woont met een warmtepomp of zonneboiler.
          Je kookt dan ook elektrisch. In al deze situaties kies je voor een alleen stroom-contract.
        </template>
      </step-info-toggle>
    </template>
  </flow-part>
</template>

<script>
import Icon from '../../../../vue-elements/icon/Icon.vue';
import WizardStepMixin from '../../../../vue-elements/wizard/lib/WizardStepMixin.js';
import HeatingTypeStep from './HeatingTypeStep.vue';
import StepInfoToggle from '../StepInfoToggle.vue';
import FlowPart from '../FlowPart.vue';
import { useEnergyComparisonStore } from '../../stores/energyComparison.js';
import BigRadioInput from '../../../../vue-elements/input/BigRadioInput.vue';

export default {
  name: 'UsageTypeStep',
  mixins: [WizardStepMixin()],
  components: {
    BigRadioInput,
    FlowPart,
    Icon,
    StepInfoToggle,
  },
  setup() {
    const comparisonStore = useEnergyComparisonStore();

    return {
      comparisonStore,
    };
  },
  data() {
    return {
      radioOption: null,
    };
  },
  watch: {
    radioOption(value) {
      if (value !== null) {
        if (this.comparisonStore.filters.noGas !== value) {
          this.logAnalyticsEvent('compare-energy.wizard-step-complete', {
            step: this.$options.name,
            value,
          });

          this.comparisonStore.filters.noGas = value;
          this.nextStep();
        }
      }
    },
  },
  created() {
    this.radioOption = this.comparisonStore.filters.noGas;
  },
  methods: {
    validate() {
      this.status = this.comparisonStore.filters.noGas !== null && (this.radioOption !== null) ? 'complete' : 'invalid';
    },
  },
};
</script>
